import { reducerTypes } from "./types";
import { IPageInfo } from "../../interfaces/common";
import { IServiceOrder } from "../../interfaces/serviceOrder";

export const getServiceOrdersAction = (data: IServiceOrder[]) => {
  return {
    type: reducerTypes.GET_ALL_SERVICEORDERS,
    payload: data,
  };
};

export const getMoreServiceOrdersAction = (data: IServiceOrder[]) => {
  return {
    type: reducerTypes.GET_MORE_SERVICEORDERS,
    payload: data,
  };
};

export const getServiceOrderAction = (data: IServiceOrder) => {
  return {
    type: reducerTypes.GET_SERVICEORDER,
    payload: data,
  };
};

export const setSizePageAction = (page: IPageInfo) => {
  return {
    type: reducerTypes.SET_PAGE_INFO,
    payload: page,
  };
};
